// extracted by mini-css-extract-plugin
export default {"main":"tqNnOizGaXcsSyWkKjru","content":"GBk4_rOIppMJwA7C4T9e","title":"ljhzCdwF052kV2yrfSHA"};